/**
 * Checks browser compatibility using feature detection rather than UA string parsing.
 *
 * Array.prototype.at() was shipped simultaneously at exactly our minimum supported
 * versions across all major browsers:
 *
 *   Chrome ≥ 92  |  Firefox ≥ 90  |  Safari ≥ 15.4  |  Edge ≥ 92  |  Opera ≥ 78
 *
 * This makes it an ideal single-signal check — no UA regex to maintain, no risk of
 * false positives from UA spoofing, and robust to new browser names/versions.
 *
 * Wrapped in try/catch to safely return false in restricted environments
 * (e.g. sandboxed iframes where Array.prototype may be inaccessible).
 *
 * @returns {boolean} true if the browser meets minimum version requirements
 */
export default function isBrowserSupported() {
  try {
    return typeof Array.prototype.at === 'function';
  } catch {
    // Unexpected environment — assume unsupported to avoid runtime errors
    return false;
  }
}
